import HBMessage from "@/components/HBMessage";
import axios from "axios";
import request, { env } from "../utils/request";

export async function getCategories() {
  const result = await request({
    url: "/v2/config",
    query: {
      fields: "categories",
    },
    ignoreError: true,
  });

  if (result?.categories) {
    return {
      categories: result.categories.filter((item) => item.display !== false),
    };
  }
}

export function getV3Config() {
  return request({
    url: "/v3/config",
    ignoreError: true,
  });
}

/**
 * https://yapi.gaoding.com/project/1536/interface/api/115801
 * @param {string|File}file {File}
 * @param {(e: progressEvent)=>void} onUploadProgress
 * @param {AbortSignal | null} signal
 * @returns {Promise<IPinFile & {err: number}>}
 */
export function uploadFile(file, onUploadProgress = null, signal = null) {
  const data = new FormData();
  data.append("file", file);
  return request({
    method: "post",
    url: "/upload",
    data,
    timeout: 0,
    ignoreCancel: true,
    onUploadProgress,
    ...(signal ? { signal } : null),
  });
}

/**
 * https://yapi.gaoding.com/project/1536/interface/api/177418
 * @param {string|File}file {File}
 * @param onUploadProgress {(e: any) => void}
 * @returns {Promise<any>}
 */
export function uploadSimilarFile(
  file,
  onUploadProgress = null,
  // 用于阻断文件上传流程
  signal = null
) {
  const data = new FormData();
  data.append("file", file);
  return request({
    method: "post",
    url: "/upload/other",
    data,
    timeout: 0,
    ignoreCancel: true,
    onUploadProgress,
    ...(signal ? { signal } : null),
  });
}

/**
 * 获取用户相关信息
 * https://yapi.gaoding.com/project/1536/interface/api/118271
 * @returns {Promise<*>}
 */
export function getMyMuseStatus() {
  return request({
    url: "/muse/me/status",
  });
}
/**
 * 举报
 * @returns {Promise<*>}
 */
export function report({ type, reason, detail, id }) {
  return request({
    method: "post",
    url: "/feedback/new-report/",
    data: {
      type,
      reason,
      detail,
      id,
    },
    ignoreMessage: true,
  });
}
/**
 * 获取为你推荐
 * @returns {Promise<*>}
 */
export function getRecommends() {
  return request({
    url: "/error/msg",
  });
}
/**
 * 获取杂货店数据
 * @template T
 * @returns {Promise<T>}
 */
export function getGrocery(
  path,
  {
    serverSide = false,
    mute = false,
    project = "huaban",
    disableCache = false,
    timeout = 10000,
  } = {}
) {
  const host = serverSide
    ? `http://gaoding-grocery.oss-cn-hangzhou${
        // 用来区分是本地运行还是服务端运行，在env.local文件中添加NEXT_RUN_ENV=local来区分
        // 因为本地无法使用内部域名访问
        process.env.NEXT_RUN_ENV === "local" ? "" : "-internal"
      }.aliyuncs.com/${project}`
    : `https://grocery-cdn.huaban.com/${project}`;

  let pathUrl = `${host}/${path}${env === "prod" ? "" : "." + env}.json`;
  if (disableCache) {
    pathUrl += `?_time=${Date.now()}`;
  }

  return axios
    .get(pathUrl, { timeout })
    .then((res) => res.data)
    .catch((error) => {
      if (!mute || !serverSide) {
        HBMessage.error("获取数据失败");
      } else if (serverSide) {
        console.warn(`杂货店获取失败:${pathUrl}`);
        console.warn(error);
      }
    });
}
/**
 *  保存用户页面配置信息
 * @returns {Promise<*>}
 */
export function savePageSetting(configs) {
  return request({
    method: "PUT",
    url: "/users/configs",
    data: {
      configs,
    },
  });
}

/**
 *  保存用户页面配置信息
 * @returns {Promise<*>}
 */
export function getWechatSignature({ url }) {
  return request({
    url: "/wechat/config",
    query: {
      url,
    },
  });
}

/**
 * 拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function toBlackList(data) {
  return request({
    method: "post",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 取消拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function outBlackList(data) {
  return request({
    method: "delete",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 获取用户黑名单列表
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number=} data.max 页码
 * @returns {Promise<{blacklists: IBlackListItem[]}>}
 **/
export function getBlackList({ item_type, max }) {
  return request({
    url: "/users/blacklists",
    query: {
      item_type,
      max,
    },
  });
}

/**
 * 检测是否被拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function checkBlackList(data) {
  return request({
    url: "/users/is_blacklist",
    query: data,
  });
}
/**
 * 获取ip
 */
export function getIp() {
  return request({
    url: "/v2/ip",
  });
}

export function getAuthKeyApi() {
  return "/v3/users/files/auth_key";
}
